clientQuery